import CampusClient from '@/api/CampusClient';

export default class FeedbackMetricsReport {
  constructor() {
    this.adminClient = null;
    this.schoolId = null;

    this.loading = false;
    this.error = null;

    this.metrics = {
      averageAppRating: 0,
      averageCounselorRating: 0,
      feedbackTotal: 0
    }
  }

  initialize($http, schoolId) {
    this.campusClient = new CampusClient($http);
    this.schoolId = schoolId;

    return this;
  }

  async fetch() {
    try {
      this.loading = true;

      this.metrics = await this.campusClient.getFeedbackMetrics(
        this.schoolId,
      );

      this.loading = false;
    } catch (error) {
      this.error = error;
    }
  }
}
